import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProductIntro() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-273" data-mp="1snhgi54oy0yf">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[440px] w-[900px] -translate-x-1/2 opacity-40" style={{
      background: 'radial-gradient(ellipse, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-274" data-mp="2ge4pktqcewmk" />
      <Container className="relative z-10 text-center" data-id="element-275" data-mp="2bm3evc8tpdyn">
        <SectionTag tone="lime" data-id="element-276" data-mp="2bkintwlpwd5j">Presentamos</SectionTag>
        <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-4xl uppercase leading-tight text-mp-white sm:text-5xl md:text-6xl" data-id="element-277" data-mp="2zb5y2oj3vev9">
          Maestro en Pista
        </h2>
        <p className="mt-3 font-heading text-sm uppercase tracking-[0.15em] text-mp-electric md:text-base" data-id="element-278" data-mp="ufoooqlccggj">
          El sistema operativo del monitor de pádel
        </p>

        <div className="mx-auto mt-8 max-w-[700px] space-y-4 text-left text-base leading-relaxed text-mp-gray md:text-center md:text-lg" data-id="element-279" data-mp="pif1lhlfcgvv">
          <p data-id="element-280" data-mp="zf1la320l1wb">
            Maestro en Pista es un sistema digital de consulta, planificación y ejecución creado para ayudarte a
            transformar conocimientos dispersos en una metodología de trabajo clara.
          </p>
          <p data-id="element-281" data-mp="1861wmsy8fv5v">
            Desde cómo enseñar una doble pared hasta cómo estructurar una sesión, gestionar niveles mixtos o
            planificar la progresión de tus alumnos.
          </p>
          <p data-id="element-282" data-mp="1i4zsyi1wgszf">Todo organizado en 5 tomos que recorren las áreas fundamentales del trabajo de un monitor.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} className="relative mx-auto mt-14 max-w-[640px]" data-id="element-283" data-mp="3owiii3bpzn42">
          <img src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista con los 5 tomos y bonos" width={800} height={800} loading="lazy" className="mx-auto w-full drop-shadow-2xl" data-id="element-284" data-mp="hi0ny96zwwb9" />
        </motion.div>

        <p className="mt-10 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray md:text-sm" data-id="element-285" data-mp="wf1hmi8qz1cd">
          5 Tomos · 250+ Páginas · 5 Bonos · Acceso Inmediato
        </p>

        <CTAButton href="#tomos" variant="secondary" size="md" className="mt-6" fullWidthMobile={false} data-id="element-286" data-mp="156tmmdf05i9k">
          Ver todo lo que incluye ↓
        </CTAButton>
      </Container>
    </section>;
}